if (document.getElementById('ee-tracking-page')) {

    // --- helpery bezpieczeństwa ---

    // Escapuje wartości wstawiane do innerHTML (ochrona przed XSS).
    function esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }

    // Dopuszcza tylko http(s) w linku trackingu (blokuje np. javascript:).
    function safeUrl(u) {
        try {
            const p = new URL(u);
            return (p.protocol === 'https:' || p.protocol === 'http:') ? p.href : '#';
        } catch {
            return '#';
        }
    }

    document
        .getElementById('orderTrackingForm')
        .addEventListener('submit', async function (e) {

            e.preventDefault();

            const orderNumber =
                document.getElementById('orderNumber').value.trim();

            const email =
                document.getElementById('orderEmail').value.trim();

            const resultBox =
                document.getElementById('tracking-result');

            resultBox.style.display = 'block';

            resultBox.innerHTML = `
                <div class="ee-result">
                    <div class="ee-result-title">
                        We're searching for your shipment...
                    </div>
                </div>
            `;

            // Blokada przycisku na czas zapytania (brak podwójnych kliknięć)
            const submitBtn = e.currentTarget.querySelector('button[type="submit"]');
            const originalBtnText = submitBtn ? submitBtn.textContent : '';
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Searching…';
            }

            try {

                const response = await fetch(
                        'https://euroelectronics-tracker.patryk-sprus.workers.dev/track',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            orderNumber,
                            email,
                            store: "IE"
                        })
                    }
                );

const data = await response.json();

// Za dużo prób (rate limit) — osobny komunikat zamiast "not found"
if (response.status === 429 || data.status === 'RATE_LIMITED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                Too many attempts
            </div>

            <div class="ee-error-message">
                You've made too many searches in a row.
                Please wait a minute and try again.
            </div>

        </div>
    `;

    return;
}

if (data.status === 'CANCELLED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                The order has been cancelled
            </div>

            <div class="ee-error-message">
                This order has been cancelled and will not be processed.
            </div>

        </div>
    `;

    return;
}

if (!data.success) {

if (data.status === 'NOT_SHIPPED') {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-pending">

                <div class="ee-result-title">
                    We're preparing your order
                </div>

<div class="ee-info-message">


 <br>

    Your order has been received and is being processed.

    <br><br>

    A tracking number hasn't been assigned yet.
    Once your shipment has been dispatched, tracking information will be available on this page and via email.

    <br><br>

    If you have any further questions about your order, please contact our customer service team.

    <br>

                    <a href="https://euroelectronics.ie/pages/contact-1" class="ee-contact-link">
                        Contact us
                    </a>

                </div>

            </div>
        `;

    } else {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-error">

                <div class="ee-result-title">
                    Order not found
                </div>

                <div class="ee-error-message">
                    We couldn't find an order matching the order number and email address provided.

                    Please make sure the details were entered correctly and try again.
                    <br><br>

                    If you need help, please contact our customer service team.
                    <br>

                    <a href="https://euroelectronics.ie/pages/contact-1" class="ee-contact-link">
                        Go to the contact form
                    </a>

                </div>

            </div>
        `;

    }

    return;
}
const productsHtml =
  (data.products || [])
    .map(product => `
 <div class="ee-product">

    <div class="ee-product-content">

        <div class="ee-product-title">
            ${esc(product.title)}
        </div>

    </div>

    <div class="ee-product-qty">
        ${esc(product.quantity)}x
    </div>

</div>
    `)
    .join('');

                resultBox.innerHTML = `
                    <div class="ee-result">

                        <div class="ee-result-title">
                            Shipment found
                        </div>
<div class="ee-result-description">
                            Below you'll find information about your shipment.
                          
                            Click the button below to go directly to tracking with the carrier.
                           
                       </div>

                       

                        <div class="ee-result-grid">

                            <div>
                                <div class="ee-result-label">
                                    Order number
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.orderNumber || orderNumber)}
                                </div>
                            </div>

                            <div>
                                <div class="ee-result-label">
                                    Tracking number
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.trackingNumber)}
                                </div>
                            </div>

                        </div>

                        <a
                            href="${safeUrl(data.trackingUrl)}"
                            target="_blank"
                            rel="noopener"
                            class="ee-track-btn"
                        >
                            Track shipment
                        </a>

                    </div>

                    <div class="ee-products-section">

  <div class="ee-products-title">
       Ordered products (${data.products?.length || 0})
  </div>

  ${productsHtml}

</div>
                `;

                resultBox.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });

            } catch (err) {

                console.error(err);

                resultBox.innerHTML = `
                    <div class="ee-result ee-result-error">

                        <div class="ee-result-title">
                            Something went wrong
                        </div>

                        <p>
                            We couldn't connect to the tracking system.
                            Please try again shortly.
                        </p>

                    </div>
                `;

            } finally {

                // Odblokowanie przycisku niezależnie od wyniku
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalBtnText;
                }

            }

        });

}